<template>
	<div class="header-container">
		<div class="header-left">
			<i :class="isCollapse ? 'el-icon-s-unfold' : 'el-icon-s-fold'" class="collapse-icon"
				@click="toggleSidebar"></i>
			<el-breadcrumb separator="/">
				<el-breadcrumb-item>{{ $t($route.meta.title) || $t('当前页面') }}</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="header-right">
			<div class="selectorTop">
				<i class="el-icon-bell" style="font-size: 20px"></i>
			</div>
			<div class="lang-selector">
				<Lang />
			</div>
			<el-dropdown trigger="click">
				<div class="user-info">
					<el-avatar size="small" :src="userInfo.avatar"></el-avatar>
					<span class="username">{{ userInfo.username }}</span>
				</div>
				<el-dropdown-menu slot="dropdown">
					<el-dropdown-item icon="el-icon-question">{{ $t('帮助') }}</el-dropdown-item>
					<el-dropdown-item icon="el-icon-user" @click.native="$nav.go('/home/personalCenter')">
						{{ $t('个人中心')}}
					</el-dropdown-item>
					<el-dropdown-item icon="el-icon-switch-button" divided @click.native="logout">
						{{ $t('退出登录') }}
					</el-dropdown-item>
				</el-dropdown-menu>
			</el-dropdown>
		</div>
	</div>
</template>

<script>
import Lang from './Lang.vue';
import { mapState } from 'vuex';

export default {
	components: {
		Lang
	},
	data() {
		return {
			// 假设状态暂时保存在组件内，实际推荐放在 Vuex
			isCollapse: false
		};
	},
	computed: {
		// 使用对象展开运算符将 Vuex 状态混入外部计算属性中
		...mapState(['userInfo']),
	},
	methods: {
		// 触发全局事件，让 Sidebar 组件监听到并折叠
		toggleSidebar() {
			this.isCollapse = !this.isCollapse;
			this.$root.$emit('togglesidebar', this.isCollapse);
		},
		logout() {
			this.$confirm(this.$t('确定退出系统吗？'), {
				type: 'warning',
				confirmButtonText: this.$t('确定'),
				cancelButtonText: this.$t('取消'),
			}).then(() => {
				localStorage.removeItem('userInfo');
				localStorage.removeItem('token');
				this.$nav.go('/'); //
			});
		}
	}
};
</script>

<style lang="scss" scoped>
.header-container {
	height: 60px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 0 20px;
	background-color: #fff;
	box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
	min-width: 900px;

	.header-left {
		display: flex;
		align-items: center;

		.collapse-icon {
			font-size: 22px;
			margin-right: 20px;
			cursor: pointer;
			color: #606266;

			&:hover {
				color: #409EFF;
			}
		}
	}

	.header-right {
		display: flex;
		align-items: center;

		.lang-selector {
			margin-right: 25px;
			cursor: pointer;
		}

		.selectorTop {
			margin-right: 25px;
			margin-top: 6px;
			cursor: pointer;
		}

		.user-info {
			display: flex;
			align-items: center;
			cursor: pointer;

			.username {
				margin-left: 8px;
				font-size: 14px;
				color: #666;
			}
		}
	}
}
</style>